import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";

type Props = {
  titles: Array<string>;
  data: Array<DataProps>;
};

type DataProps = {
  Incharge: string[];
  Members: string[];
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 16,
  lineHeight: "22px !important",
}));

function CommitteeTable({ titles, data }: Props) {
  return (
    <TableContainer
      component={Paper}
      sx={{ width: "100%", overflowX: "scroll" }}
    >
      <Table>
        <TableHead
          sx={{ backgroundColor: "primary.main", color: "text.primary" }}
        >
          <TableRow>
            {titles.map((title, i) => (
              <TableCell key={i} sx={{ border: 1 }}>
                {title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item, rowIndex) => {
            const maxLength = Math.max(
              item.Incharge.length,
              item.Members.length
            );

            return (
              <React.Fragment key={rowIndex}>
                {Array.from({ length: maxLength }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell sx={{ color: "primary.main", border: 1 }}>
                      {i + 1}
                    </TableCell>
                    {i === 0 &&
                      item.Members.length > item.Incharge.length &&
                      item.Incharge.length <= 1 && (
                        <TableCell
                          rowSpan={maxLength} // Span across all member rows
                          sx={{ color: "primary.main", border: 1 }}
                        >
                          {item.Incharge[i] || ""}
                        </TableCell>
                      )}
                    {item.Incharge.length > 1 && (
                      <TableCell sx={{ color: "primary.main", border: 1 }}>
                        {item.Incharge[i] || ""}
                      </TableCell>
                    )}
                    <TableCell sx={{ color: "primary.main", border: 1 }}>
                      {item.Members[i] || ""}
                    </TableCell>
                  </TableRow>
                ))}
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CommitteeTable;
